import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Gender } from '@enums/gender';
import { Pharmacy } from '@enums/pharmacies';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { TreatmentGenderSettings } from '@models/treatment-types/treatment-gender-settings.model';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the TRT treatment type.
 */
export const TrtTreatmentType = new TreatmentType({
  id: '17',
  name: ConsultationTreatmentTypes.Trt,
  restrictedStates: [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CT',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OK',
    'OR',
    'RI',
    'SC',
    'SD',
    'TN',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
    'DC',
    'PR',
  ],
  stateRestrictionExemptTestIds: [3591],
  restrictedStatesError: 'We do not offer TRT treatments in your state at this time.',
  designatedPharmacyId: Pharmacy.EMPOWER,
  genderSettings: new TreatmentGenderSettings({
    disallowed: [Gender.Female],
    errorMessage: 'TRT treatments are only available for male patients.',
  }),
  requireHeightAndWeight: true,
  eligibleTreatmentTypes: [
    { id: 3682, name: UpsellSlugs.InjectableTrtAndHcgUpsell },
    { id: 3683, name: UpsellSlugs.OralTrtAndEnclomipheneUpsell },
    { id: 3684, name: UpsellSlugs.TrtGelAndEnclomipheneUpsell },
  ],
  minAgeAllowed: 20,
});
